import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api';

export default function GuestLookup() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [eventError, setEventError] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    api.getEventPublic(slug).then(setEvent).catch(() => setEventError(true));
  }, [slug]);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (query.trim().length < 2) {
      setResults([]);
      setSearched(false);
      return;
    }
    setLoading(true);
    debounceRef.current = setTimeout(async () => {
      try {
        const rows = await api.lookupPublic(slug, query.trim());
        setResults(rows);
      } catch (e) {
        setResults([]);
      } finally {
        setLoading(false);
        setSearched(true);
      }
    }, 350);
    return () => clearTimeout(debounceRef.current);
  }, [query, slug]);

  if (eventError) {
    return (
      <div className="lookup-page">
        <div className="lookup-ornament">✦</div>
        <p className="lookup-hint">Nuk u gjet asnjë dasmë me këtë link. Kontrolloni kodin QR ose kontaktoni mikpritësin.</p>
      </div>
    );
  }

  return (
    <div className="lookup-page">
      <div className="lookup-ornament">✦</div>
      <h1 className="lookup-title">{event?.couple_names || '…'}</h1>
      {event?.wedding_date && <p className="lookup-date">{event.wedding_date}</p>}

      {!selected && (
        <>
          <p className="lookup-subtitle">Shkruani emrin tuaj për të gjetur tavolinën</p>
          <input
            autoFocus
            className="lookup-input"
            type="text"
            placeholder="p.sh. Ardit Krasniqi"
            value={query}
            onChange={(e) => setSelected(null) || setQuery(e.target.value)}
          />

          {loading && <p className="lookup-hint">Duke kërkuar…</p>}

          {!loading && searched && results.length === 0 && (
            <p className="lookup-hint">
              Nuk u gjet asnjë mysafir me këtë emër. Provoni ta shkruani ndryshe, ose drejtohuni te mikpritësi.
            </p>
          )}

          {results.length > 0 && (
            <ul className="lookup-results">
              {results.map((g) => (
                <li key={g.id}>
                  <button onClick={() => setSelected(g)}>{g.full_name}</button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}

      {selected && (
        <div className="lookup-answer">
          <p className="lookup-answer-name">{selected.full_name}</p>
          {selected.status === 'cancelled' ? (
            <p className="lookup-cancelled">Rezervimi juaj është shënuar si i anuluar. Ju lutem kontaktoni mikpritësin.</p>
          ) : selected.table_label ? (
            <>
              <p className="lookup-answer-label">jeni ulur në</p>
              <p className="lookup-table">{selected.table_label}</p>
              {selected.seat_number && <p className="lookup-seat">Vendi Nr. {selected.seat_number}</p>}
            </>
          ) : (
            <p className="lookup-hint">Tavolina juaj do të konfirmohet së shpejti. Pyesni mikpritësin.</p>
          )}
          <button className="lookup-back" onClick={() => { setSelected(null); setQuery(''); setResults([]); setSearched(false); }}>
            ← Kërko përsëri
          </button>
        </div>
      )}
    </div>
  );
}
